export default {
  version: "55xl-1qcy",
};
